(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("testVue", [], factory);
	else if(typeof exports === 'object')
		exports["testVue"] = factory();
	else
		root["testVue"] = factory();
})(window, function() {
return 